var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03986 15H18.9601C19.5362 14.9648 20 14.4453 20 13.8164V1.18359C20 0.535156 19.5109 0.00390625 18.9094 0H1.09058C0.48913 0.00390625 0 0.535156 0 1.18359V13.8125C0 14.4453 0.463768 14.9648 1.03986 15Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60145 8.99609V15H11.3841V8.99609H20V5.99609H11.3841V0H8.60145V5.99609H0V8.99609H8.60145Z",
    fill: "#C8102E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3115 4.85547V0H18.9166C19.3731 0.0078125 19.7644 0.316406 19.9238 0.75L12.3115 4.85547Z",
    fill: "#012169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3115 10.1447V15.0002H18.9601C19.3985 14.9728 19.768 14.6681 19.9238 14.2502L12.3115 10.1447Z",
    fill: "#012169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.674 10.1447V15.0002H1.03994C0.601534 14.9728 0.228346 14.6681 0.0761719 14.2424L7.674 10.1447Z",
    fill: "#012169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.674 4.85547V0H1.08342C0.626896 0.0078125 0.231969 0.320312 0.0761719 0.757812L7.674 4.85547Z",
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.99982H2.77174L0 3.50372V4.99982Z",
    fill: "#012169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 5.00017H17.2139L20.0001 3.49626V5.00017Z",
    fill: "#012169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10.0002H17.2139L20.0001 11.5041V10.0002Z",
    fill: "#012169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0002H2.77174L0 11.4963V10.0002Z",
    fill: "#012169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 1.2697L13.0977 5.00017H14.6411L19.9998 2.10954V1.2697Z",
    fill: "#C8102E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88768 10.0002H5.3442L0 12.883V13.7228L6.90217 10.0002H6.88768Z",
    fill: "#C8102E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81159 5.00406H5.35507L0 2.11343V2.94937L3.81159 5.00406Z",
    fill: "#C8102E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1704 9.99626H14.627L20.0001 12.8986V12.0627L16.1704 9.99626Z",
    fill: "#C8102E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFlag);
export default __webpack_public_path__ + "static/media/en-flag.456c5e61e6c91e8c86749894e8156576.svg";
export { ForwardRef as ReactComponent };